/**
 * Edit Pause Dialog (iter271 — extracted from Enrollments.js).
 * Lets admin update the auto-resume date / notes on an already-paused enrollment.
 */
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { Pencil, PlayCircle, Check } from 'lucide-react';

export default function EditPauseDialog({
  open,
  onOpenChange,
  selectedEnrollment,
  editPauseData,
  setEditPauseData,
  formatDateOnly,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl flex items-center gap-2">
            <Pencil className="h-5 w-5 text-amber-500" />
            Edit Pause Settings
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="p-3 bg-slate-50 rounded-lg">
            <p className="font-medium text-slate-900">{selectedEnrollment?.player_name}</p>
            <p className="text-sm text-slate-500">Program: {selectedEnrollment?.program_name}</p>
            <p className="text-sm text-amber-600">Status: Paused</p>
            {selectedEnrollment?.pause_date && (
              <p className="text-xs text-slate-500 mt-1">
                Paused since: {formatDateOnly(selectedEnrollment.pause_date, { weekday: undefined, year: 'numeric', month: 'numeric', day: 'numeric' })}
              </p>
            )}
          </div>

          <div className="space-y-2">
            <Label className="flex items-center gap-2">
              <PlayCircle className="h-4 w-4 text-green-500" />
              Auto-Resume Date
            </Label>
            <Input
              type="date"
              value={editPauseData.auto_resume_date}
              onChange={(e) => setEditPauseData({ ...editPauseData, auto_resume_date: e.target.value })}
              data-testid="edit-pause-auto-resume-input"
            />
            <p className="text-xs text-slate-500">
              {editPauseData.auto_resume_date
                ? 'Enrollment will auto-resume on this date'
                : 'Leave empty to require manual resume'}
            </p>
          </div>

          <div className="space-y-2">
            <Label>Notes (Optional)</Label>
            <Textarea
              value={editPauseData.notes}
              onChange={(e) => setEditPauseData({ ...editPauseData, notes: e.target.value })}
              placeholder="Reason for change..."
              data-testid="edit-pause-notes-input"
            />
          </div>

          <DialogFooter className="flex justify-end gap-3 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
            <Button
              className="bg-amber-500 hover:bg-amber-600"
              onClick={onConfirm}
              data-testid="confirm-edit-pause-btn"
            >
              <Check className="h-4 w-4 mr-1" />
              Save Changes
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
